<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const helpLink = 'https://telegram.me/step_bot_support';
</script>

<template>
	<a
		:href="helpLink"
		target="_blank"
		rel="noopener noreferrer"
		class="part-welcome-help"
	>
		<span class="part-welcome-help__text">{{ t('welcome.help') }}</span>
		<img src="/images/welcome/icon-telegram.svg" alt="" class="part-welcome-help__icon" />
	</a>
</template>

<style lang="scss">
.part-welcome-help {
	position: fixed;
	bottom: 1.5rem;
	right: 1.5rem;
	z-index: 50;
	display: flex;
	align-items: center;
	gap: 1.6rem;
	height: 4rem;
	padding: 0 0.8rem 0 2.4rem;
	border-radius: 10rem;
	border: 1px solid rgba(var(--color-active-rgb), 0.12);
	background: #fff;
	text-decoration: none;
	color: rgba(0, 28, 51, 0.5);
	transition: background-color ease 0.17s, box-shadow ease 0.17s;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

	&:active {
		background: #f0f0f0;
	}

	@include min-desktop {
		bottom: 4rem;
		right: 8rem;
		height: 6.2rem;
		padding: 0 0.8rem 0 2.4rem;
		color: rgba(0, 0, 0, 1);

		&:hover {
			background: #f5f3fa;
			box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
		}
	}

	@include theme-dark {
		background: #1a1a2e;
		color: rgba(var(--color-text-rgb), 1);
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
		border-color: rgba(var(--color-active-rgb), 0.2);

		&:active {
			background: #252540;
		}

		@include min-desktop {
			&:hover {
				background: #222240;
				box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
			}
		}
	}

	&__text {
		@include font-regular;
		white-space: nowrap;

		@include min-desktop {
			@include font-18-pro-medium;
		}
	}

	&__icon {
		width: 2.5rem;
		height: 2.5rem;
		flex-shrink: 0;
		border-radius: 50%;

		@include min-desktop {
			width: 4.8rem;
			height: 4.8rem;
		}

		@include theme-dark {
			background: rgba(255, 255, 255, 0.12);
		}
	}
}
</style>
